export default function downloadURI(uri, name) {
  let link: HTMLAnchorElement | null = document.createElement('a')
  link.download = name
  link.href = uri
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  link = null
}
